import { handleActions } from "redux-actions";

import { setPlatforms } from "./actions";

const initialState = {
    isLoadingPlatforms: false,
    platforms: {},
    codes: []
};

export const platformsReducer = handleActions(
    {
        [setPlatforms]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
